export const PROCESSING_STUDENTS = "PROCESSING_STUDENTS";
export const PROCESSING_STUDENT = "PROCESSING_STUDENT";
export const GET_STUDENTS_DATA = "GET_STUDENTS_DATA";
export const GET_STUDENT_DATA = "GET_STUDENT_DATA";
export const CREATE_STUDENT = "CREATE_STUDENT";
export const UPDATE_STUDENT = "UPDATE_STUDENT";
export const DELETE_STUDENT = "DELETE_STUDENT";
